import {warehouseFinishedDetailRestUrl} from "../warehousefinisheddetail/WarehouseFinishedDetailService";
import axios from "axios";
import ObjectUtil from "../../../../utils/common/ObjectUtil";
import {
    detailServicesPath, ordersServicesPath
} from "../../../../Constants";

const detailOrderRestUrl = detailServicesPath + '/organizations/details-order'
const detailOrderRestUrlOrders = ordersServicesPath + '/organizations/details-order'
const orderOptimizationRestUrl = ordersServicesPath + '/organizations/optimizations'

const detailOrderUpdateNumber = (value) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
};

/** PUT …/details-order/{id} — только поля UpdateDetailDto (Swagger). */
export const buildDetailOrderUpdateBody = (detail) => {
    const row = detail && typeof detail === "object" ? detail : {};
    return {
        name: row.name ?? null,
        position: row.position ?? null,
        length: detailOrderUpdateNumber(row.length),
        width: detailOrderUpdateNumber(row.width),
        height: detailOrderUpdateNumber(row.height),
        quantity: detailOrderUpdateNumber(row.quantity),
        counterTop: Boolean(row.counterTop),
    };
};

export const detailOrderIdsEqual = (left, right) =>
    left != null && right != null && String(left) === String(right);

/** Строка таблицы после PUT: полный DetailDto с бэка или merge формы в прежнюю строку. */
export const applyDetailOrderUpdateToRow = (previousRow, responseData, mergedFormRow) => {
    if (responseData && typeof responseData === "object" && responseData.id != null) {
        return responseData;
    }
    const base = previousRow && typeof previousRow === "object" ? previousRow : {};
    const patch = mergedFormRow && typeof mergedFormRow === "object" ? mergedFormRow : {};
    return {
        ...base,
        ...patch,
        id: base.id ?? patch.id,
    };
};

export default class DetailService {

    static async getById(id) {
        return axios.get(detailOrderRestUrl + "/" + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllByOptimizationId(optimizationId, calculation) {
        let url = detailOrderRestUrl + '/for-optimization?optimizationId=' + optimizationId;
        if (calculation != null) {
            url += '&calculation=' + calculation;
        }
        return axios.get(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getModelDetails() {
        return axios.get(detailOrderRestUrl + '/model', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getModelDetailById(id) {
        return axios.get(detailOrderRestUrl + '/model/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async addModelDetails(data) {
        return axios.post(detailOrderRestUrl + '/model', JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async updateModelDetails(data, id) {
        return axios.post(detailOrderRestUrl + '/model/' + id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteModelDetails(id) {
        return await axios.delete(detailOrderRestUrl + '/model/' + id, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    /** DELETE …/details-order/model/by-ids — body: массив id деталей. */
    static async deleteModelDetailsByIds(ids) {
        const idList = Array.isArray(ids) ? ids : [];
        return axios.delete(`${detailOrderRestUrl}/model/by-ids`, {
            data: JSON.stringify(idList),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    static async getByEstimateId(estimateId) {
        return axios.get(detailOrderRestUrl + '/model/estimate?estimateId=' + estimateId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getForCuttingMap(cuttingMapId, calculation) {
        let url = detailOrderRestUrl + '/for-cutting-map?cuttingMapId=' + cuttingMapId;
        if (calculation != null) {
            url += '&calculation=' + calculation;
        }
        return axios.get(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllByRequestsCuttingId(requestsCuttingId) {
        return axios.get(detailOrderRestUrl + '/by-requests-cutting-id?requestsCuttingId=' + requestsCuttingId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllByRequestsCuttingIdByCloud(requestsCuttingId) {
        return axios.get(detailOrderRestUrl + '/by-requests-cutting-id-by-cloud?requestsCuttingId=' + requestsCuttingId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }


    static async unableCutOrTurn(id, status, typeStatus, warehouse) {
        let url = null;
        if (warehouse === 'WarehouseFinishedDetail') {
            url = warehouseFinishedDetailRestUrl
        } else if (warehouse === 'orders') {
            url = detailOrderRestUrl
        }
        return axios.patch(url + '/' + id + '/unable-' + typeStatus + '?status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async updateCutOrTurnByIds(ids, status, typeStatus, warehouse) {
        let url = null;
        if (warehouse === 'WarehouseFinishedDetail') {
            url = warehouseFinishedDetailRestUrl
        } else if (warehouse === 'orders') {
            url = detailOrderRestUrl
        }
        let data = ObjectUtil.createUpdateRequestObjectIds(ids, status);
        await axios.post(url + '/update-cut-and-turn-by-ids'
            + '?status=' + status + '&typeStatus=' + typeStatus,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async delete(id, warehouse) {
        let url = null;
        if (warehouse === 'WarehouseFinishedDetail') {
            url = warehouseFinishedDetailRestUrl
        } else if (warehouse === 'orders') {
            url = detailOrderRestUrl
        }
        await axios.delete(url + '/' + +id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async updateOptimization(data, optimizationId) {
        return await axios.put(detailOrderRestUrl + '/' + data.id + '/for-optimization', JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(data, warehouse) {
        let url = null;
        if (warehouse === 'WarehouseFinishedDetail') {
            url = warehouseFinishedDetailRestUrl
        } else if (warehouse === 'orders') {
            url = detailOrderRestUrl
        }
        const body = buildDetailOrderUpdateBody(data);
        return await axios.put(url + '/' + data.id, JSON.stringify(body), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(data, requestsCuttingId, warehouse) {
        let url = null;
        if (warehouse === 'WarehouseFinishedDetail') {
            url = warehouseFinishedDetailRestUrl
        } else if (warehouse === 'orders') {
            url = detailOrderRestUrl
        }
        return await axios.post(url + '?requestsCuttingId=' + requestsCuttingId, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async createTXTFileSelco(ids, optimizationNumber) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.post(detailOrderRestUrl + '/download/file-txt-selco' + '?optimizationNumber=' + optimizationNumber, JSON.stringify(data), {
            responseType: "arraybuffer",
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async saveOptimizations(data, optimizationId, materialId) {
        return await axios.post(detailOrderRestUrl + '/save-for-optimization' + '?optimizationId=' + optimizationId + '&materialId=' + materialId, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async modifyOptimizations(optimizationId, ids) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(orderOptimizationRestUrl + '/' + optimizationId + '/modify', JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteModify(optimizationId) {
        return await axios.patch(detailOrderRestUrl + '/delete-modify?optimizationId=' + optimizationId, null, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteFromOptimization(id, optimizationId) {
        return await axios.delete(detailOrderRestUrl + '/' + id + '/optimization' + '?optimizationId=' + optimizationId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllNotUsedDetailsWorkingCuttingMapId(workingCuttingMapId) {
        return axios.get(detailOrderRestUrlOrders + '/not-used-details-by-working-cutting-map-id?workingCuttingMapId=' + workingCuttingMapId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}